<template>
  <div class="header">
    <div style="float: left"><BreadCrumb /></div>
    <div class="base-header">
      <ul>
        <!-- <el-badge is-dot class="item"> -->
        <!-- <li class="header-item" style="width: 22px">
        </li> -->
        <!-- </el-badge> -->
        <li class="header-item el-dropdown-link">
          <el-dropdown>
            <i class="iconfont icon-account"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openModifyPassword">修改密码</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </div>
    <ModifyPassword :showWindow="showWindow" @closeWindow="closeWindow"/>
  </div>
</template>

<script type="text/ecmascript-6">
import ModifyPassword from 'pages/ModifyPassword'
import BreadCrumb from 'components/BreadCrumb'
import Login from 'api/login'
const _login = new Login()

export default {
  data () {
    return {
      showWindow: false,
      showSearchInput: false
    }
  },
  methods: {
    openSearch() {
      this.showSearchInput = true
      this.$nextTick(() => {
        this.$refs.searchInput.focus()
      })
    },
    closeSearch() {
      this.showSearchInput = false
    },
    // 打开修改密码
    openModifyPassword() {
      this.showWindow = true
    },
    closeWindow() {
      this.showWindow = false
    },
    logout() {
      localStorage.removeItem('Labtoken')
      localStorage.removeItem('BASE_URL')
      localStorage.removeItem('SCHOOL_ID')
      this.$router.push('/o/login')
    }
  },
  components: {
    ModifyPassword,
    BreadCrumb
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable.styl'

.header
  position relative
  background #fff
  height 60px
  box-shadow: rgba(0, 21, 41, 0.08) 0px 1px 4px
  .base-header
    float right
    ul
      overflow hidden
      .header-item
        float left
        height 60px
        line-height 60px
        padding 0 15px
        font-size 16px
        cursor pointer
        transition all .3s
        text-align center
        &.search
          box-sizing border-box
          padding 0
          overflow hidden
          &:hover
            background #fff
        &:hover
          background #e6f7ff
        .search-input
          height 36px
          border-bottom 1px solid #d9d9d9
          &::-webkit-input-placeholder
            color #ccc
        .icon-account
          padding 10px
          border-radius 50%
          background #ccc
          color #fff
</style>
